import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd-v5';
import React from 'react';
import QuickViewSkeletonCard from './QuickViewSkeletonCard';

const QuickViewSection = ({ children, title, addButton = true, onViewAllClick, onAddClick, isLoading }) => {
  return (
    <div className="flex-col gap-16 p-x-22">
      <div className="flex-row items-center justify-between w-100-P">
        <div className="flex-row items-center gap-16">
          <h2 className="fs-15 fw-500 m-btm-0">{title}</h2>
          {addButton && <PlusOutlined className="fs-18 pointer" onClick={onAddClick} />}
        </div>
        {onViewAllClick && (
          <Button type="link" onClick={onViewAllClick} className="cb-link-btn">
            View All
          </Button>
        )}
      </div>
      {isLoading
        ? Array(2)
          .fill(null)
          .map((_, index) => <QuickViewSkeletonCard key={index} hasFooter />)
        : children}
    </div>
  );
};

export default QuickViewSection;
